import * as React from 'react';
import { cn } from './lib/utils';
import { useTheme } from '../../contexts/ThemeContext';
import NNLineChart from '../shared/NNLineChart';
import { getChartTheme } from '../../utils/chartTheme';

/**
 * Thin wrapper around shared/NNLineChart that:
 * - Accepts a `className` for layout control
 * - Injects dark-mode axis/grid/tooltip colours
 */
function NNLineChartWidget({ className, height, ...props }) {
  const theme = useTheme();
  const colors = getChartTheme(theme);

  return (
    <div className={cn('w-full', className)}>
      <NNLineChart
        height={height}
        themeOverrides={colors}
        {...props}
      />
    </div>
  );
}

export { NNLineChartWidget };
